import Cookies from "js-cookie";

/**
 * El usuario con sesión, leído fuera de React.
 *
 * `AuthContext` lo guarda en la cookie `user` al iniciar sesión y la refresca con
 * `updateCurrentUser`, así que un servicio lo encuentra ahí mismo sin depender del
 * árbol de componentes. Es la misma lectura que ya hacen `syncService` y la base.
 *
 * @returns {object|null} El usuario, o `null` si no hay sesión o la cookie no se lee.
 */
export const usuarioEnSesion = () => {
  try {
    const crudo = Cookies.get("user");
    return crudo ? JSON.parse(crudo) : null;
  } catch {
    return null;
  }
};
